import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { WithContext as ReactTags } from 'react-tag-input';
import Select from 'react-select';
import { getAllHome } from '../../actions/home';
import { getAllCityAction } from '../../actions/FindRecCompany';
import { employementType, RULESMESSAGE, experienceArr } from '../../_constants';
import makeAnimated from 'react-select/lib/animated';
import { addjobAction, updateJobAction, jobListByComAction } from '../../actions/job';
import { notification } from 'antd';
import loadingImage from "../loadingImageRc.gif";
let className = "";

const KeyCodes = {
    comma: 188,
    enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

let Validator = require('validatorjs');
let styleData = { color: "red" }
let formArr = {};
let rules = {
    title: 'required',
    summary: 'required',
    description: 'required',
    roleCategory: 'required',
};

let validation = [];
validation = new Validator([], rules, RULESMESSAGE);
validation.passes();
validation.fails();

class JobEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jobFromData: {
                title: "",
                description: "",
                summary: "",
                experienceRequired: "",
                jobLocation: [],
                opening: "",
                salary: "",
                keySkill: [],
                jobRole: "",
                employementType: {},
                education: [],
                roleCategory: []
            },
            requestServer: false,
            tags: [],
            tagvalue: [],
            educationValue: [],
            jobRoleValue: [],
            keySkillValue: [],
            formArr: {},
            resumeCountRecivied: 0,
            unreadNotificationCount: 0,
            latestResumedata: []
        };
        this.upDateProfile = this.upDateProfile.bind(this)
    }

    componentWillMount() {
  
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        switch (nextProps.responseType) {
            case "jobEditData":
            if(nextProps.response && !this.props.editModal){
                let  jobData = nextProps.response
				if (jobData.employementType) {
				    jobData.employementType = { label: jobData.employementType, value: jobData.employementType }
				}
				if (jobData.experienceRequired) {
				    jobData.experienceRequired = { label: jobData.experienceRequired, value: jobData.experienceRequired }
				}
                this.setState({
                    jobFromData: jobData
                })
            }
                break;   
            case "addJob":
                notification.success({
                    message: nextProps.response.msg,
                    className:'successNotification',
                    duration: 3
                });
                this.setState({
                    requestServer: false
                })
                break;
            case "updateJob":
                notification.success({
                    message: nextProps.response.msg,
                    className:'successNotification',
                    duration: 3
                });
                this.setState({
                    requestServer: false,
                    jobFromData:{}
                })
                break;
            default:
                return true;
        }
    }

    handleDelete = (name, i) => {
        var nameState = this.state[name];
        this.setState({
            [name]: nameState.filter((tag, index) => index !== i),
        });
    }

    handleDrag = (name, tag, currPos, newPos) => {
        const tags = [...this.state[name]];
        const newTags = tags.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        this.setState({
            [name]: newTags
        });
    }

    handleAddition = (name, tag) => {
        this.setState(state => ({
            [name]: [...state[name], tag]
        }));
    }

    handleChange = e => {
        e.preventDefault();
        let { jobFromData } = this.state;
        jobFromData[e.target.name] = e.target.value;
        this.setState({ jobFromData: jobFromData });
    };

    handleChangeSelect = (name, value) => {
        let jobFromData = this.state.jobFromData
        jobFromData["categoryId"] = [];
        jobFromData[name] = value
        for (var i in value) {
            jobFromData["categoryId"].push(value[i].value);
        }
        this.setState({
            jobFromData: jobFromData
        });
    }

    upDateProfile() {
        this.setState({
            requestServer: true
        })
        if (this.allValidate(false)) {
            let jobFromData = this.state.jobFromData;
            jobFromData.id=jobFromData._id
            let educationValue = this.state.educationValue;
            let keySkillValue = this.state.keySkillValue;
            let arrA = []
            let arrB = []
            for (var x in keySkillValue) {
                arrA.push(keySkillValue[x].text)
            }
            for (var y in educationValue) {
                arrB.push(educationValue[y].text)
            }
            jobFromData.keySkill = arrA
            jobFromData.education = arrB
            jobFromData.experienceRequired = jobFromData.experienceRequired && jobFromData.experienceRequired.value;
            jobFromData.employementType = jobFromData.employementType && jobFromData.employementType.value;
            this.setState({
                requestServer: true
            })
            this.props.updateJobAction(jobFromData)
        }
    }

    handleChangeSelectCity = (name, value) => {
        let jobFromData = this.state.jobFromData
        jobFromData.jobLocation = value;

        this.setState({
            jobFromData: jobFromData
        });
    }

    allValidate(check) {
        if (!check) {
            formArr = []
            Object.keys(rules).forEach(function(key) {
                formArr[key] = "TT";
            });
            this.setState({
                formArr
            });

        }
        if (validation.passes()) {
            return 1;
        }
    }


    render() {
        const { cityOption, categoryOption, action, editModal } = this.props
       
        const {  keySkillValue, educationValue, suggestions, requestServer, jobFromData } = this.state;
        validation = new Validator(jobFromData, rules, RULESMESSAGE);
        validation.passes();
        validation.fails();

        if (requestServer) {
            className = "pageloading";
        } else {
            className = "";
        }
        return (
       
         
    		<Modal backdrop="static" keyboard={false} isOpen={editModal} toggle={action} className="detail-modal modal-lg">
    		    <ModalHeader toggle={action}>&nbsp;Edit Job</ModalHeader>
    		    <ModalBody>
                    <div className={"pageForLoading "+className}>
                        <div className=" wrap">
                            <div className="loading">
                                <img src={loadingImage} alt="Loading" />
                            </div>
                        </div>
                    </div>
    		       
		            <div className="col-md-12">
		                <div className="form-group">
		                    <div className="row">
		                        <div className="bg-signup col-md-12">
		                            <div className="row">
		                                <div className="col-md-12">
		                                    <div className="form-group">
		                                        <label className="pf-label">Job Title<span>*</span></label>
		                                        <input type="text" className="form-control singup-control" name="title" onChange={this.handleChange} placeholder="Job Title" value={jobFromData.title} />
		                                        <span style={styleData} className="error">{this.state.formArr.title && validation.errors.first('title')}</span>
		                                    </div>
		                                </div>
		                                <div className="col-md-3">
		                                    <div className="form-group">
		                                        <label className="pf-label">Employment Type</label>
		                                        <Select name="employmentType" className="singup-control" closeMenuOnSelect={true} components={makeAnimated()} value={jobFromData.employementType} onChange={this.handleChangeSelect.bind(this, "employementType" )} options={employementType} disabled={true} placeholder="Select Category" />
		                                    </div>
		                                </div>
		                                <div className="col-md-3">
		                                    <div className="form-group">
		                                        <label className="pf-label">Experience</label>
		                                        <Select name="employmentType" className="singup-control" closeMenuOnSelect={true} components={makeAnimated()} value={jobFromData.experienceRequired} onChange={this.handleChangeSelect.bind(this, "experienceRequired" )} options={experienceArr} disabled={true} placeholder="Select Category" />
		                                    </div>
		                                </div>
		                                <div className="col-md-3">
		                                    <div className="form-group">
		                                        <label className="pf-label">Opening</label>
		                                        <input type="text" className="form-control singup-control form-design" name="opening" onChange={this.handleChange} placeholder="Opening" value={jobFromData.opening} />
		                                    </div>
		                                </div>
		                                <div className="col-md-3">
		                                    <div className="form-group">
		                                        <label className="pf-label">Salary</label>
		                                        <input type="text" className="form-control singup-control form-design" name="salary" onChange={this.handleChange} placeholder="Salary" value={jobFromData.salary} />
		                                    </div>
		                                </div>
		                            </div>
		                            <div className="row">
		                                <div className="col-md-12">
		                                    <div className="form-group">
		                                        <label className="pf-label">Job Summary<span>*</span></label>
		                                        <textarea type="text" rows="4" className="form-control singup-control" name="summary" onChange={this.handleChange} placeholder="Job Summary" value={jobFromData.summary}></textarea>
		                                        <span style={styleData} className="error">{this.state.formArr.summary && validation.errors.first('summary')}</span>
		                                    </div>
		                                </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="pf-label">Job Description<span>*</span></label>
                                                <textarea type="text" rows="4" className="form-control singup-control" name="description" onChange={this.handleChange} placeholder="Job Description" value={jobFromData.description}></textarea>
                                                <span style={styleData} className="error">{this.state.formArr.description && validation.errors.first('description')}</span>
                                            </div>
                                        </div>
		                                <div className="col-md-12">
		                                    <div className="form-group">
		                                        <label className="pf-label">Role Category<span>*</span></label>
		                                        <Select name="field" className="singup-control" isMulti closeMenuOnSelect={false} components={makeAnimated()} value={jobFromData.roleCategory} onChange={this.handleChangeSelect.bind(this, "roleCategory" )} options={categoryOption} disabled={true} placeholder="Select Category" />
		                                        <span style={styleData} className="error">{this.state.formArr.roleCategory && validation.errors.first('roleCategory')}</span>
		                                    </div>
		                                </div>
		                                <div className="col-md-12 custom-field">
		                                    <div className="form-group">
		                                        <label className="pf-label">Job Role<span>*</span></label>
		                                        <input type="text" className="form-control singup-control" name="jobRoleValue" onChange={this.handleChange} placeholder="Job Title" value={jobFromData.jobRoleValue} />
		                                    </div>
		                                </div>
		                            </div>
		                            <div className="row">
		                                <div className="col-md-12 custom-field">
		                                    <div className="form-group">
		                                        <label className="pf-label">Key Skill</label>
		                                        <ReactTags className="serach-Box in-custom-control"  tags={keySkillValue} suggestions={suggestions} handleDelete={this.handleDelete.bind(this,'keySkillValue')} handleAddition={this.handleAddition.bind(this,'keySkillValue')} handleDrag={this.handleDrag.bind(this,'keySkillValue')} delimiters={delimiters}  disabled={true} />
		                                    </div>
		                                </div>
		                            </div>
		                            <div className="row">
		                                <div className="col-md-12 custom-field">
		                                    <div className="form-group">
		                                        <label className="pf-label">Education</label>
		                                        <ReactTags className="serach-Box in-custom-control"  tags={educationValue} suggestions={suggestions} handleDelete={this.handleDelete.bind(this,'educationValue')} handleAddition={this.handleAddition.bind(this,'educationValue')} handleDrag={this.handleDrag.bind(this,'educationValue')} delimiters={delimiters}  disabled={true} />
		                                    </div>
		                                </div>
		                            </div>
		                            <div className="row">
		                                <div className="col-md-12">
		                                    <div className="form-group">
		                                        <label className="pf-label" htmlFor="city"> Location </label>
		                                        <Select name="jobLocation" className="singup-control" isMulti closeMenuOnSelect={false} components={makeAnimated()} value={jobFromData.jobLocation} onChange={this.handleChangeSelectCity.bind(this, "jobLocation" )} options={cityOption} disabled={true} placeholder="Select City" />
		                                        {/* {jobFromData.userType&&
		                                        <MultiPleCitySuggstion props={this.props} />
		                                        }*/}
		                                        {/*<input type="text" className="form-control" name="city" id="jobCity" value={ jobFromData && jobFromData.city} placeholder=" City" disabled />*/}
		                                    </div>
		                                </div>
		                            </div>
		                        </div>
		                    </div>
		                </div>
		            </div>
    		      
    		    </ModalBody>
    		    <div className="modal-btn-block">
    		        <ModalFooter>
    		            <div className="row">
    		                <div className="col-md-12">
    		                    <div className="button-block">
    		                        <button className="cancel-btn pull-right" onClick={action}>Cancel</button>
    		                        <button className="save-btn update-btn pull-right" onClick={this.upDateProfile}>Update</button>
    		                    </div>
    		                </div>
    		            </div>
    		        </ModalFooter>
    		    </div>
    		</Modal>
        
        );
    }
}

function mapStateToProps(state) {
    return {
        allCitySuggetion: state.FindRecCompany.allCitySuggetion,
        responseType: state.Job.type,
        fieldsCategory: state.home.response.data,
        //resumeCount: state.home.responseCount,
        response: state.Job.response,
    };
}
export default withRouter(connect(mapStateToProps, {
    addjobAction,
    updateJobAction,
    jobListByComAction,
    getAllCityAction,
    getAllHome
})(JobEdit));


// WEBPACK FOOTER //
// ./src/components/Job/JobEdit.js